import { useAuth } from '@/contexts/AuthContext';

export function LoginPage() {
  const { login, isLoading, error } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-secondary via-[#001029] to-secondary">
      <div className="max-w-md w-full mx-4">
        <div className="card bg-white/10 backdrop-blur-lg border-white/20 text-center">
          {/* Logo */}
          <div className="mb-8">
            <div className="w-16 h-16 mx-auto bg-primary rounded-2xl flex items-center justify-center mb-4">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-white mb-2">
              Discovery Engine
            </h1>
            <p className="text-white/60">
              Adaptive Conversational Discovery
            </p>
          </div>

          {/* Description */}
          <div className="mb-8 text-white/80 text-sm">
            <p>
              Voice-powered process discovery that transforms conversations
              into process maps, SIPOC models, and actionable insights.
            </p>
          </div>

          {/* Login Button */}
          <button
            onClick={login}
            disabled={isLoading}
            className="w-full btn btn-primary py-3 text-base font-medium flex items-center justify-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? (
              <>
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                Signing in...
              </>
            ) : (
              <>
                <svg className="w-5 h-5" viewBox="0 0 21 21" fill="currentColor" aria-hidden="true">
                  <path d="M0 0h10v10H0V0zm11 0h10v10H11V0zM0 11h10v10H0V11zm11 0h10v10H11V11z" />
                </svg>
                Sign in with Microsoft
              </>
            )}
          </button>

          {/* Error Message */}
          {error && (
            <div className="mt-4 p-3 bg-red-500/20 border border-red-500/50 rounded-lg text-red-200 text-sm">
              {error}
            </div>
          )}

          {/* Footer */}
          <div className="mt-8 pt-6 border-t border-white/10">
            <p className="text-white/40 text-xs">
              ANZ Enterprise Application Team
            </p>
            <p className="text-white/40 text-xs mt-1">
              © {new Date().getFullYear()} Datacom Systems Limited
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
